import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { getPlatformExportDescriptor } from '@app/modules/social-export/domain/platform-export-descriptors';
import { useWatch } from 'react-hook-form';

interface Props {
  platform: SocialPlatform;
  fieldPrefix?: string;
}

/**
 * Renders platform-specific export settings when the platform is enabled.
 * Only platforms that register QuickExportSettings expose additional fields.
 */
export function QuickSocialExportSettings({ platform, fieldPrefix }: Props) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const fieldName = `${fieldPrefix || ''}.enabled`.replace(/^\./, '') as any;
  const enabled = useWatch({ name: fieldName });

  if (!enabled) {
    return null;
  }

  const { QuickExportSettings } = getPlatformExportDescriptor(platform);
  if (!QuickExportSettings) {
    return null;
  }

  return <QuickExportSettings fieldPrefix={fieldPrefix} />;
}
